export default{
    checkLogin:function(){
          if(sessionStorage.getItem('LoginUserId')){
			  return true;
		  }else{
			  return false;
		  }
    }
}


// WEBPACK FOOTER //
// ./src/common/js/login.js